import { useState } from "react";
import { useParams } from "react-router-dom";
import { toastMe } from "../../../../utils";
import { updateCustomHeader } from "../../../../utils/requests";
import { HeaderState, PublishCode } from "../types";
import { generatePublishCode } from "../utils/publishUtils";

export function usePublishCode(state: HeaderState) {
	const { id: headerId } = useParams<{ id: string }>();

	const [showPublishModal, setShowPublishModal] = useState(false);
	const [showPreviewModal, setShowPreviewModal] = useState(false);
	const [publishedCode, setPublishedCode] = useState<PublishCode>({
		html: "",
		css: "",
	});

	const handlePublish = async () => {
		const code = generatePublishCode(state);
		setPublishedCode(code);

		if (headerId) {
			try {
				await updateCustomHeader(headerId, {
					settings: {
						content: code.html,
						styles: code.css,
						headerState: state,
						// config: generateHeaderConfigs(state),
						config: code.config || {},
					},
				});

				toastMe("Header updated successfully", "success");
			} catch (error) {
				console.error("Error updating header:", error);
			}
		}

		setShowPublishModal(true);
	};

	const handlePreview = () => {
		setShowPreviewModal(true);
	};

	return {
		showPublishModal,
		setShowPublishModal,
		showPreviewModal,
		setShowPreviewModal,
		publishedCode,
		handlePublish,
		handlePreview,
	};
}
